import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-angle-left',
  templateUrl: './angle-left.component.html',
  styleUrls: ['./angle-left.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AngleLeftIconComponent {}
